<template>
    <div class="wizard__wrap" style="max-width: 1200px">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">
                    {{ agencyName }}
                </div>
            </div>

            <div class="wizard__block-dealname">
                {{ deal_name }}
            </div>

            <div class="wizard__block-title">
                Kick-off date
            </div>

            <div class="wizard_sale_wrap row">
                <div class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls">
                    <div class="title">
                        If you have started providing service, please fill in kick-off date, or select "Not started" or
                        "Canceled" otherwise:
                    </div>
                    <div class="">
                        <div class="form-field form-field--radiobutton" v-for="t in kick_off_types">
                            <input type="radio" :id="`type_${t.id}`" v-model="upsell.kick_off_type"
                                :checked="upsell.kick_off_type === t.id" name="type_id"
                                class="type-create-deals js-edit-deal-type" :value="t.id"
                                @change="onChangeKickOffType" />
                            <label style="
                                    margin-bottom: 5px;
                                    margin-right: 12px;
                                " :for="`type_${t.id}`">{{ t.name }}</label>
                            <div class="form-field form-field--datepicker" ref="datepicker" v-if="t.id === 1">
                                <input :disabled="upsell.kick_off_type !== 1" type="text" id="kickoff_date"
                                    class="input-kick-off-date" v-model="upsell.kick_off_date" name="kickoff_date"
                                    @changeDate="onChangeDatePicker" />
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>

                            <div class="wizard_sale__sow" v-if="t.id === 1">
                                <div class="form-field checkbox-wrap checkbox-wrap--one-time-setup "
                                    style="margin-top: 4px">
                                    <input type="checkbox" id="have_sow_signed_sow" name="have_sow_signed_sow"
                                        class="financial-details-checkbox" :disabled="!upsell.kick_off_date"
                                        :checked="upsell.is_has_signed_sow"
                                        @change="upsell.is_has_signed_sow = !upsell.is_has_signed_sow" />
                                    <label for="have_sow_signed_sow">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                    I have signed SOW
                                </div>

                                <div class="wizard_sale__sow-types"
                                    :style="`display: ${upsell.is_has_signed_sow ? 'block' : 'none'}`">

                                    <div class="wizard_sale__sow-type">

                                        <div class="form-field form-field--radiobutton">
                                            <input type="radio" :id="`sow_type_file`" v-model="upsell.selected_sow_type"
                                                name="sow_type" class="type-create-deals js-edit-deal-type" value="file"
                                                :checked="upsell.selected_sow_type === 'file'"
                                                @change="onChangeSowType" />
                                            <label style="margin-bottom: 5px; margin-right: 12px; "
                                                :for="`sow_type_file`">File</label>
                                        </div>

                                        <div class="form-field form-field--file" ref="filepicker">
                                            <input type="file" id="agreement" :disabled="!upsell.is_sow_file"
                                                name="agreement" hidden ref="fileInput" @input="pickFile"
                                                @change="pickFile" />
                                            <button type="button"
                                                :disabled="upsell.is_sow_file === null || !upsell.is_sow_file"
                                                class="btn btn--file">
                                                File
                                                <i class="icon icon-plus"></i>
                                            </button>
                                            <span class="filename" v-if="upsell.sow_filename">{{ upsell.sow_filename
                                                }}</span>
                                        </div>

                                    </div>

                                    <div class="wizard_sale__sow-type">

                                        <div class="form-field form-field--radiobutton">
                                            <input type="radio" :id="`sow_type_url`" name="sow_type"
                                                v-model="upsell.selected_sow_type" value="url"
                                                class="type-create-deals js-edit-deal-type"
                                                :checked="upsell.selected_sow_type === 'url'"
                                                @change="onChangeSowType" />
                                            <label style="margin-bottom: 5px; margin-right: 12px; "
                                                :for="`sow_type_url`">URL</label>
                                        </div>

                                        <div class="form-field form-field--text">
                                            <input type="text" id="sow_url"
                                                :disabled="upsell.is_sow_file === null || upsell.is_sow_file"
                                                v-model="upsell.sow_url" name="sow_url" />
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 wizard_sale_details">
                    <div class="title">
                        Service details
                    </div>
                    <div class="row" v-if="upsell.services[0]">
                        <div class="label">
                            Service:
                        </div>
                        <div class="value">
                            {{ getServiceName(upsell.services[0]) || '-' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.custom_service">
                        <div class="label">
                            Custom service:
                        </div>
                        <div class="value">
                            {{ upsell.custom_service || '-' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="label">
                            Type:
                        </div>
                        <div class="value">
                            {{ getTypeName(upsell.type) || '-' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.kickoff_date">
                        <div class="label">
                            Kick-off date:
                        </div>
                        <div class="value">
                            {{ kickOffDateFormat(upsell.kickoff_date) }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 1 && upsell.mounthly_fee && !upsell.is_fluctuating_fee">
                        <div class="label">
                            Monthly fee:
                        </div>
                        <div class="value">
                            ${{ numberWithCommas(upsell.mounthly_fee) || '-' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 1 && upsell.is_fluctuating_fee">
                        <div class="label">
                            Fluctuating fee:
                        </div>
                        <div class="value">
                            {{ upsell.is_fluctuating_fee ? 'Yes' : 'No' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 1 && upsell.frequency_retainer">
                        <div class="label">
                            Frequency:
                        </div>
                        <div class="value">
                            {{ Number(upsell.frequency_retainer) === 1 ? '1m' : '1y' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 2 && upsell.full_amount">
                        <div class="label">
                            Full amount:
                        </div>
                        <div class="value">
                            ${{ numberWithCommas(upsell.full_amount) || '-' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 2 && upsell.number_of_pmts">
                        <div class="label">
                            Number of pmts:
                        </div>
                        <div class="value">
                            {{ upsell.number_of_pmts || '-' }}
                        </div>
                    </div>
                    <div class="row" v-if="upsell.type === 3 && upsell.one_time_fee">
                        <div class="label">
                            One-time fee:
                        </div>
                        <div class="value">
                            ${{ numberWithCommas(upsell.one_time_fee) || '-' }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button type="button" @click="onPrevSection" class="btn btn--prev btn--white">
                    Previous
                </button>
                <button type="button" @click="onSaveNewUpsell" class="btn btn--next btn--gray">
                    Next
                </button>
            </div>

            <div class="loader" v-if="isLoading">
                <clip-loader :loading="isLoading" :color="'#ec4657'" :size="'45px'"></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader";

import CurrencyInput from "../../../components/CurrencyInput";
import { Datepicker } from "vanillajs-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { SECTIONS } from "../consts";
import axios from "axios";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Edit_KickOff_Date",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isLoading: false,
            services_list: [],
            deal_name: "",
            brand_types: [
                {
                    id: 1,
                    name: "Retainer",
                },
                {
                    id: 2,
                    name: "Project",
                },
                {
                    id: 3,
                    name: "One-Time Fee",
                },
            ],
            kick_off_types: [
                {
                    id: 1,
                    name: "Kick-off date"
                },
                {
                    id: 2,
                    name: "Not started"
                },
                {
                    id: 3,
                    name: "Canceled"
                }
            ],
            upsell: {
                id: 0,
                services: [],
                kick_off_date: null,
                custom_service: "",
                terms: "",
                is_kick_off_canceled: false,
                kick_off_type: null,
                type: 1,
                one_time_fee: "",
                mounthly_fee: "",
                full_amount: "",
                number_of_pmts: "",
                is_fluctuating_fee: false,
                frequency_retainer: null,
                is_has_signed_sow: false,
                is_sow_file: null,
                sow_filename: "",
                sow_file: null,
                sow_url: "",
            },
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
                autohide: true,
            },
            wizard_draft_sow_id: null,
            errors: {
                kick_off_type: null,
                type_sow: null,
                is_has_file: null,
                is_has_url: null,
                kick_off_date: null,
            },
            urlRegex:
                /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
            dealLineItemsWithoutKickOffDate: null,
            currentPageKickOff: 1,
            totalPagesOfKickOff: 1,
            is_create_custom_service: false,
            datePickerControl: null,
        };
    },
    components: {
        Treeselect,
        ClipLoader,
        CurrencyInput,
    },

    created() {
        this.getData();
    },

    mounted() {
        this.initDatePicker();
        this.initFilePicker();


    },
    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        }
    },
    methods: {
        async getData(is_update = false) {
            await axios
                .post("/api/wizard/getList", {
                    page: "edit_upsell",
                })
                .then((res) => {
                    this.dealLineItemsWithoutKickOffDate = res.data.page.deals;
                    this.services_list = res.data.page.services;
                    this.checkIfHaveDealLineItems(is_update);
                    this.$nextTick(() => {
                        scrollToTop(); // Прокрутка вверх
                    });
                })
                .catch((err) => console.log("err getData upsell", err));
        },
        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker.length) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker[0].querySelector("input");
            const button = node__datepicker[0].querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, this.datepicker_options);
                this.datePickerControl = datepicker;
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.upsell.kick_off_date = date;
            }
        },

        onChangeKickOffType() {

            switch (this.upsell.kick_off_type) {
                case 1:
                    this.upsell.is_kick_off_canceled = false;
                    this.upsell.kick_off_date = null;
                    this.datePickerControl.dates = [];
                    if (this.datePickerControl.pickerElement && this.datePickerControl.pickerElement.querySelector(".selected")) this.datePickerControl.pickerElement.querySelector(".selected").classList.remove('selected', 'focused')
                    break;
                case 2:
                    this.upsell.kick_off_date = null;
                    this.upsell.is_has_signed_sow = false;
                    this.datePickerControl.dates = [];
                    if (this.datePickerControl.pickerElement && this.datePickerControl.pickerElement.querySelector(".selected")) this.datePickerControl.pickerElement.querySelector(".selected").classList.remove('selected', 'focused')
                    break;
                case 3:
                    this.upsell.is_kick_off_canceled = true;
                    this.upsell.kick_off_date = null;
                    this.upsell.is_has_signed_sow = false;
                    this.datePickerControl.dates = [];
                    if (this.datePickerControl.pickerElement && this.datePickerControl.pickerElement.querySelector(".selected")) this.datePickerControl.pickerElement.querySelector(".selected").classList.remove('selected', 'focused')
                    break;
            }
        },

        onNextPage() {

            if (this.currentPageKickOff === this.totalPagesOfKickOff) {
                this.onChangeSection(SECTIONS.EDIT_SALE_LINE_ITEM, SECTIONS.EDIT_KICK_OFF_LINE_ITEM);
                return;
            }

            this.setCurrentLineItem(this.currentPageKickOff + 1);
            this.currentPageKickOff = this.currentPageKickOff + 1;

            this.$nextTick(() => {
                scrollToTop(); // Прокрутка вверх
            });
        },

        onPrevSection() {
            if (this.currentPageKickOff === 1) {
                this.onChangeSection(SECTIONS.DASHBOARD, SECTIONS.EDIT_KICK_OFF_LINE_ITEM);
                return;
            }
            this.setCurrentLineItem(this.currentPageKickOff - 1);
            this.currentPageKickOff = this.currentPageKickOff - 1;

            this.$nextTick(() => {
                scrollToTop(); // Прокрутка вверх
            });
        },

        onSaveNewUpsell() {

            this.validateFields();

            if (
                this.errors.kick_off_type ||
                this.errors.is_has_file ||
                this.errors.is_has_url ||
                this.errors.type_sow ||
                this.errors.kick_off_date
            ) {
                return;
            }

            this.isLoading = true;

            const data = {
                deal_line_item_id: this.upsell.id,
                kickoff_date: this.upsell.kick_off_date,
                is_kick_off_canceled: this.upsell.is_kick_off_canceled,
                kick_off_type: this.upsell.kick_off_type,
                is_has_signed_sow: this.upsell.is_has_signed_sow,
                is_sow_file: this.upsell.is_sow_file,
                sow_filename: this.upsell.sow_filename,
                sow_url: this.upsell.sow_url,
                selected_sow_type: null,
            };

            const formData = new FormData();

            formData.append("action", "updateDealLineItem");
            formData.append("data", JSON.stringify(data));
            formData.append(
                "file",
                this.upsell.sow_file === null ? "" : this.upsell.sow_file
            );

            axios
                .post("/api/wizard/updateDraft", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(async () => {
                    //this.$toast.success("Upsell has been saved!");
                    this.getData(true);
                    this.onNextPage();

                })
                .catch((err) => {
                    this.$toast.error("Something went wrong!");
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },
        createRetainerSale() {

            const data = {
                deal_line_item_id: this.upsell.id
            }

            axios
                .post("/api/wizard/updateDraft", {
                    action: "createRetainerSale",
                    data: data,
                })
                .then(() => {
                    //this.$toast.success("Upsell has been saved!");
                    this.onNextPage();
                })
                .catch((err) => {
                    this.$toast.error("Something went wrong!");
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },
        validateFields() {

            this.errors.kick_off_type = null;
            this.errors.type_sow = null;
            this.errors.is_has_file = null;
            this.errors.is_has_url = null;
            this.errors.kick_off_date = null;

            if (!this.upsell.kick_off_type) {
                this.errors.kick_off_type = true;
                this.$toast.error("You should choose an answer")
            }

            if (this.upsell.kick_off_type === 1 && !this.upsell.kick_off_date) {
                this.errors.kick_off_date = true;
                this.$toast.error("You should choose a kick-off date")
            }

            if (this.upsell.is_has_signed_sow) {

                if (this.upsell.is_sow_file === null) {
                    this.errors.type_sow = true;
                    this.$toast.error("You should choose a type of SOW")
                } else {
                    if (this.upsell.is_sow_file && (!this.upsell.sow_file && !this.upsell.sow_filename)) {
                        this.errors.is_has_file = true;
                        this.$toast.error("You should upload SOW file")
                    } else if (!this.upsell.is_sow_file && !this.upsell.sow_url) {
                        this.errors.is_has_url = true;
                        this.$toast.error("You should enter SOW url")
                    } else if (!this.upsell.is_sow_file && this.upsell.sow_url && !this.urlRegex.test(this.upsell.sow_url)) {
                        this.errors.is_has_url = true;
                        this.$toast.error("Invalid URL");
                    }

                }

            }
        },

        checkIfHaveDealLineItems(is_update = false) {
            const deal_ids = Object.keys(this.dealLineItemsWithoutKickOffDate);

            if (deal_ids.length > 0) {

                this.totalPagesOfKickOff = Object.values(this.dealLineItemsWithoutKickOffDate).flat().length;

                if (!is_update) this.setCurrentLineItem(1);

            } else {

                this.onChangeSection(SECTIONS.EDIT_SALE_LINE_ITEM, SECTIONS.EDIT_KICK_OFF_LINE_ITEM)

            }
        },

        setCurrentLineItem(index) {

            if (Object.keys(this.dealLineItemsWithoutKickOffDate).length > 0) {

                const dealLineItems = Object.values(this.dealLineItemsWithoutKickOffDate).flat();

                this.upsell.id = dealLineItems[index - 1].deal_line_item_id;
                this.upsell.services = dealLineItems[index - 1].service_id;
                this.upsell.kick_off_date = dealLineItems[index - 1].kickoff_date;
                this.upsell.custom_service = dealLineItems[index - 1].custom_service;
                if (dealLineItems[index - 1].custom_service) {
                    this.is_create_custom_service = true;
                }
                this.upsell.type = dealLineItems[index - 1].type_id || dealLineItems[index - 1].commission_type_id;
                this.upsell.number_of_pmts = dealLineItems[index - 1].num_of_payments || dealLineItems[index - 1].payments_number;
                this.upsell.terms = dealLineItems[index - 1].terms;
                this.upsell.mounthly_fee =
                    dealLineItems[index - 1].type_id === 1 ? dealLineItems[index - 1].amount : "";
                this.upsell.full_amount = dealLineItems[index - 1].type_id === 2 ? dealLineItems[index - 1].amount : "";
                this.upsell.one_time_fee =
                    dealLineItems[index - 1].type_id === 3 ? dealLineItems[index - 1].amount : "";
                this.upsell.is_fluctuating_fee = dealLineItems[index - 1].fluctuating_fee;
                this.upsell.kick_off_type = dealLineItems[index - 1].hasOwnProperty("kick_off_type") ? dealLineItems[index - 1].kick_off_type : null;
                this.deal_name = dealLineItems[index - 1].deal_name || "",
                    this.upsell.frequency_retainer = dealLineItems[index - 1].frequency_retainer;

                this.upsell.sow_url = "";
                this.upsell.sow_filename = "";
                this.upsell.is_sow_file = null;
                this.upsell.selected_sow_type = null;
                this.upsell.sow_file = null;

                if (dealLineItems[index - 1].hasOwnProperty("is_has_signed_sow")) {
                    this.upsell.is_has_signed_sow = dealLineItems[index - 1].is_has_signed_sow;
                } else if (dealLineItems[index - 1].kickoff_date) {
                    this.upsell.is_has_signed_sow = true;
                } else {
                    this.upsell.is_has_signed_sow = false;
                }

                if (dealLineItems[index - 1].hasOwnProperty("is_sow_file")) {
                    if (dealLineItems[index - 1].is_sow_file) {
                        this.upsell.is_sow_file = true
                        this.upsell.selected_sow_type = "file";
                        this.upsell.sow_filename = dealLineItems[index - 1].sow_filename;
                    } else if (dealLineItems[index - 1].is_sow_file === null) {
                        this.upsell.is_sow_file = null
                    } else {
                        this.upsell.is_sow_file = false
                        this.upsell.selected_sow_type = "url";
                        this.upsell.sow_url = dealLineItems[index - 1].sow_url;
                    }
                }

                else if (dealLineItems[index - 1].hasOwnProperty("sow_url")) {
                    this.upsell.sow_url = dealLineItems[index - 1].sow_url;
                    this.upsell.selected_sow_type = "url";
                    this.upsell.is_sow_file = false
                }

                else if (dealLineItems[index - 1].hasOwnProperty("sow_filename")) {
                    this.upsell.sow_filename = dealLineItems[index - 1].sow_filename;
                    this.upsell.selected_sow_type = "file";
                    this.upsell.is_sow_file = true
                }

            }

        },

        getServiceName(id) {
            if (this.services_list.length) {

                const service = this.services_list.find(i => i.id === id);

                if (service) {
                    return service.label;
                }
            }

            return ""
        },

        getTypeName(id) {
            if (id) {

                const type = this.brand_types.find(i => i.id === id);

                if (type) {
                    return type.name;
                }
            }

            return ""
        },

        numberWithCommas(x) {
            if (!x) {
                return "0";
            }

            let fixednumber = Number(x).toFixed(2);
            let parts = fixednumber.split(".");

            let integerPart = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

            let formattedNumber = integerPart + "." + parts[1];

            return formattedNumber;
        },

        onChangeSowType(e) {

            const value = e.target.value;

            if (value === "file") {
                this.upsell.is_sow_file = true;
                this.upsell.sow_url = "";

            } else if (value === 'url') {
                this.upsell.sow_file = null;
                this.upsell.is_sow_file = false;
            }
            this.upsell.selected_sow_type = value;
        },

        pickFile() {
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(file[0]);
                this.new_sow.file = file[0];
            }
        },

        initFilePicker() {
            const inputField = this.$refs.filepicker;

            if (!inputField[0]) {
                return;
            }

            const button = inputField[0].querySelector("button");
            const input = inputField[0].querySelector("input");
            const filenameNode = inputField[0].querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    this.upsell.sow_filename = filename;
                    //filenameNode.innerHTML = filename;
                    this.upsell.sow_file = file[0];
                }
            });
        },
        kickOffDateFormat(date = null) {
            if (date) {
                const formattedDate = moment(date).format('MM/DD/YYYY');

                return formattedDate;
            }

            return ""
        }
    },
};
</script>
